/* lettra: Produktseite NFC-Notfallanhaenger (sections/lettra-nfc.liquid).
   Eigenstaendig — der Bubble-Konfigurator war nur technisches Vorbild,
   es werden keine Dateien geteilt. Drei Aufgaben:
   1. Vorschau in zwei Ebenen: Bei den Pastelltoenen wird das
      Koerper-Render per Canvas-multiply eingefaerbt und die weisse
      Schrift-Ebene unveraendert darueber gelegt; Wolkenweiss nutzt
      das fertige Schwarz-Schrift-Bild (URLs aus
      snippets/nfc-assets.liquid; fehlen Dateien, zeigt der
      onerror-Pfad die Platzhalter-Flaeche).
   2. Notfalldaten: Bei "Von uns aufgespielt" klappt der Feldblock
      direkt unter den Optionskarten auf (Name + Telefon, Werte gelten
      sofort); bei "Selbst aufspielen" klappt er zu. Inline-Fehler
      erscheinen erst nach dem ersten Klick auf den Warenkorb-CTA, der
      dann zum ersten leeren Feld scrollt und fokussiert.
   3. Warenkorb: /cart/add mit properties[Farbe], [Daten auf dem Chip]
      und — bei "Von uns aufgespielt" — [Name] und [Telefon]. */
(function () {
  'use strict';

  /* Kundennamen und Hex-Werte der vier Anhaengerfarben. "einfaerben"
     waehlt den Vorschauweg: Bei den Pastelltoenen wird das
     Koerper-Render per multiply eingefaerbt und die weisse
     Schrift-Ebene unveraendert darueber gelegt (bleibt weiss). Bei
     Wolkenweiss laeuft das fertige Schwarz-Schrift-Bild durch
     denselben Weg — multiply mit #ffffff ist die Identitaet. */
  var NFC_FARBEN = [
    { id: 'zuckerwatte', label: 'Zuckerwatte', hex: '#f7ced8', einfaerben: true },
    { id: 'himmelblau', label: 'Himmelblau', hex: '#a5dae8', einfaerben: true },
    { id: 'abendsonne', label: 'Abendsonne', hex: '#ffb672', einfaerben: true },
    { id: 'wolkenweiss', label: 'Wolkenweiß', hex: '#ffffff', einfaerben: false }
  ];

  var NFC_BESCHRIFTUNGEN = [
    { id: 'unbeschrieben', label: 'Selbst aufspielen' },
    { id: 'beschrieben', label: 'Von uns aufgespielt' }
  ];

  /* Fallback-Preise in Cent, falls das Produkt (noch) keine Varianten
     hat — z. B. in der Theme-Vorschau vor dem Anlegen im Admin. */
  var NFC_PREIS_BASIS = 1290;
  var NFC_PREIS_AUFPREIS = 250;

  function nfcEuro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init(root) {
    var els = {
      variants: root.querySelector('[data-nfc-variants]'),
      canvas: root.querySelector('[data-nfc-canvas]'),
      platzhalter: root.querySelector('[data-nfc-platzhalter]'),
      platzhalterDatei: root.querySelector('[data-nfc-platzhalter-datei]'),
      farben: root.querySelector('[data-nfc-farben]'),
      beschriftungen: root.querySelector('[data-nfc-beschriftungen]'),
      daten: root.querySelector('[data-nfc-daten]'),
      name: root.querySelector('[data-nfc-name]'),
      nameFehler: root.querySelector('[data-nfc-name-fehler]'),
      telefon: root.querySelector('[data-nfc-telefon]'),
      telefonFehler: root.querySelector('[data-nfc-telefon-fehler]'),
      selbstHinweis: root.querySelector('[data-nfc-selbst-hinweis]'),
      sFarbe: root.querySelector('[data-nfc-s-farbe]'),
      sBeschriftung: root.querySelector('[data-nfc-s-beschriftung]'),
      sNameRow: root.querySelector('[data-nfc-s-name-row]'),
      sName: root.querySelector('[data-nfc-s-name]'),
      sTelefonRow: root.querySelector('[data-nfc-s-telefon-row]'),
      sTelefon: root.querySelector('[data-nfc-s-telefon]'),
      sTotal: root.querySelector('[data-nfc-s-total]'),
      cta: root.querySelector('[data-nfc-cta]'),
      ctaDots: root.querySelector('[data-nfc-cta] .lettra-btn__dots'),
      error: root.querySelector('[data-nfc-error]')
    };
    if (!els.daten || !els.name || !els.telefon) {
      /* Nicht still weiterlaufen — ein stummer Guard hat schon einmal
         einen Bug verdeckt. */
      console.warn('lettra-nfc: Notfalldaten-Block unvollständig — '
        + 'Felder sind ohne Funktion.');
    }

    var variants = [];
    try {
      variants = JSON.parse(els.variants.textContent) || [];
    } catch (e) {
      variants = [];
    }

    var state = {
      farbe: 'zuckerwatte',
      beschriftung: 'unbeschrieben'
    };

    function farbVonId(id) {
      for (var i = 0; i < NFC_FARBEN.length; i++) {
        if (NFC_FARBEN[i].id === id) return NFC_FARBEN[i];
      }
      return NFC_FARBEN[0];
    }
    function beschriftungVonId(id) {
      for (var i = 0; i < NFC_BESCHRIFTUNGEN.length; i++) {
        if (NFC_BESCHRIFTUNGEN[i].id === id) return NFC_BESCHRIFTUNGEN[i];
      }
      return NFC_BESCHRIFTUNGEN[0];
    }

    function variantFor(farbeId, beschriftungId) {
      var f = farbVonId(farbeId).label;
      var b = beschriftungVonId(beschriftungId).label;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].o1 === f && variants[i].o2 === b) return variants[i];
      }
      return null;
    }

    function preisFuer(farbeId, beschriftungId) {
      var v = variantFor(farbeId, beschriftungId);
      if (v) return v.price;
      return beschriftungId === 'beschrieben' ? NFC_PREIS_BASIS + NFC_PREIS_AUFPREIS : NFC_PREIS_BASIS;
    }

    /* ---------- Vorschau: Canvas-Einfaerbung ----------
       Drei Schritte wie beim Tuer-Konfigurator: Schattierung zeichnen,
       multiply-Farbfuellung, Alphakante per destination-in
       zurueckholen. mask-image nicht erneut versuchen (WebP-Masken
       versagen still — die Flaeche bleibt leer). */
    var bilder = {};
    function ladeRender(key) {
      if (bilder[key]) return bilder[key];
      bilder[key] = new Promise(function (resolve, reject) {
        var daten = (window.LETTRA_NFC && window.LETTRA_NFC.renders && window.LETTRA_NFC.renders[key]) || null;
        if (!daten) {
          reject(new Error('Renderdaten fehlen'));
          return;
        }
        var img = new Image();
        img.onload = function () { resolve(img); };
        img.onerror = function () { reject(new Error(daten.datei)); };
        img.src = daten.url;
      });
      return bilder[key];
    }

    function malAnhaenger(canvas, img, hex, ueberlagerung) {
      var box = canvas.parentElement.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var cssW = box.width;
      var cssH = cssW * (img.naturalHeight / img.naturalWidth);
      var w = Math.max(1, Math.round(cssW * dpr));
      var h = Math.max(1, Math.round(cssH * dpr));
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w;
        canvas.height = h;
      }
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);              /* Schattierung inkl. Alpha */
      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = hex;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(img, 0, 0, w, h);              /* Alphakante zurueckholen */
      ctx.globalCompositeOperation = 'source-over';
      /* Weisse Schrift-Ebene unveraendert ueber den eingefaerbten
         Koerper — deckungsgleiche Renders, gleiche Zielgroesse. */
      if (ueberlagerung) ctx.drawImage(ueberlagerung, 0, 0, w, h);
    }

    function renderVorschau() {
      var farbe = farbVonId(state.farbe);
      /* Pastell: Koerper-Render einfaerben, weisse Schrift-Ebene
         unveraendert darueber. Wolkenweiss: fertiges Schwarz-Bild
         durch denselben Weg. */
      var laden = farbe.einfaerben
        ? Promise.all([ladeRender('koerper_only'), ladeRender('schrift_only_weiss')])
        : ladeRender('schrift_schwarz').then(function (img) { return [img, null]; });
      laden
        .then(function (bilder) {
          /* Farbe erst hier abfragen: Ein schneller Farbwechsel
             waehrend des Ladens darf nicht den alten Modus malen. */
          var aktuelle = farbVonId(state.farbe);
          if (aktuelle.einfaerben !== farbe.einfaerben) return;
          /* Erst malen, wenn wirklich ALLE benoetigten Ebenen fertig
             geladen sind — sonst Platzhalter statt eines halb
             gemalten Bilds. */
          if (!bilder[0] || !bilder[0].naturalWidth) {
            throw new Error('Render unvollständig geladen');
          }
          if (aktuelle.einfaerben && (!bilder[1] || !bilder[1].naturalWidth)) {
            throw new Error('Render unvollständig geladen');
          }
          if (els.platzhalter) els.platzhalter.classList.remove('is-visible');
          if (els.canvas) {
            els.canvas.style.display = '';
            malAnhaenger(els.canvas, bilder[0], aktuelle.hex, bilder[1]);
          }
        })
        .catch(function (err) {
          /* Sichtbare Platzhalter-Flaeche — ladeRender wirft den
             fehlenden Dateinamen als Fehlermeldung. */
          if (els.canvas) els.canvas.style.display = 'none';
          if (els.platzhalter) {
            els.platzhalter.classList.add('is-visible');
            if (els.platzhalterDatei) {
              els.platzhalterDatei.textContent = String((err && err.message) || 'unbekannt');
            }
          }
        });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(renderVorschau, 150);
    });

    /* ---------- Optionskarten ---------- */
    function baueFarben() {
      NFC_FARBEN.forEach(function (f) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lettra-opt';
        btn.setAttribute('role', 'radio');
        btn.dataset.nfcFarbe = f.id;
        btn.innerHTML =
          '<b><span class="nfc-swatch" style="background:' + f.hex + '"></span>' + f.label + '</b>';
        btn.addEventListener('click', function () {
          state.farbe = f.id;
          sync();
        });
        els.farben.appendChild(btn);
      });
    }

    function baueBeschriftungen() {
      NFC_BESCHRIFTUNGEN.forEach(function (b) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lettra-opt';
        btn.setAttribute('role', 'radio');
        btn.dataset.nfcBeschriftung = b.id;
        btn.innerHTML = '<b>' + b.label + '</b><small data-nfc-preiszeile></small>';
        btn.addEventListener('click', function () {
          state.beschriftung = b.id;
          /* sync() klappt den Notfalldaten-Block auf bzw. zu. */
          sync();
        });
        els.beschriftungen.appendChild(btn);
      });
    }

    function preiszeilen() {
      var basis = preisFuer(state.farbe, 'unbeschrieben');
      var voll = preisFuer(state.farbe, 'beschrieben');
      var zeilen = els.beschriftungen.querySelectorAll('[data-nfc-preiszeile]');
      if (zeilen[0]) zeilen[0].textContent = nfcEuro(basis);
      if (zeilen[1]) zeilen[1].textContent = '+ ' + nfcEuro(voll - basis);
    }

    /* ---------- Notfalldaten-Felder ---------- */
    function feldFehler(input, fehlerEl, zeigen) {
      if (!input || !fehlerEl) return;
      input.setAttribute('aria-invalid', zeigen ? 'true' : 'false');
      fehlerEl.classList.toggle('is-visible', zeigen);
    }

    /* Inline-Fehler an Name/Telefon; Rueckgabe: alles gueltig?
       anzeigen wird nur vom Warenkorb-CTA gesetzt — vorher bleiben
       die Felder neutral (erster Validierungsversuch). */
    function pflichtfelderPruefen(anzeigen) {
      var nameOk = !!(els.name && els.name.value.trim());
      var telefonOk = !!(els.telefon && els.telefon.value.trim());
      if (anzeigen) {
        feldFehler(els.name, els.nameFehler, !nameOk);
        feldFehler(els.telefon, els.telefonFehler, !telefonOk);
      }
      return nameOk && telefonOk;
    }

    /* Die Werte gelten sofort (kein Uebernehmen-Button): Tippen
       aktualisiert die Zusammenfassung und loescht den Inline-Fehler
       des Felds. */
    function feldVerdrahten() {
      [[els.name, els.nameFehler], [els.telefon, els.telefonFehler]].forEach(function (paar) {
        if (!paar[0]) return;
        paar[0].addEventListener('input', function () {
          feldFehler(paar[0], paar[1], false);
          notfalldatenZusammenfassung();
        });
      });
    }

    function notfalldatenZusammenfassung() {
      if (els.sName) {
        els.sName.textContent = (els.name && els.name.value.trim()) || 'Noch keine Angabe';
      }
      if (els.sTelefon) {
        els.sTelefon.textContent = (els.telefon && els.telefon.value.trim()) || 'Noch keine Angabe';
      }
    }

    /* ---------- Zusammenfassung & Auswahlzustand ---------- */
    function sync() {
      var farbe = farbVonId(state.farbe);
      var beschriftung = beschriftungVonId(state.beschriftung);

      els.farben.querySelectorAll('[data-nfc-farbe]').forEach(function (btn) {
        var aktiv = btn.dataset.nfcFarbe === state.farbe;
        btn.classList.toggle('is-selected', aktiv);
        btn.setAttribute('aria-checked', aktiv ? 'true' : 'false');
      });
      els.beschriftungen.querySelectorAll('[data-nfc-beschriftung]').forEach(function (btn) {
        var aktiv = btn.dataset.nfcBeschriftung === state.beschriftung;
        btn.classList.toggle('is-selected', aktiv);
        btn.setAttribute('aria-checked', aktiv ? 'true' : 'false');
      });

      if (els.sFarbe) els.sFarbe.textContent = farbe.label;
      if (els.sBeschriftung) els.sBeschriftung.textContent = beschriftung.label;

      var beschrieben = state.beschriftung === 'beschrieben';
      /* Notfalldaten-Block auf-/zuklappen (CSS animiert die Hoehe);
         der Anleitungs-Hinweis gilt nur fuer "Selbst aufspielen". */
      if (els.daten) els.daten.classList.toggle('is-offen', beschrieben);
      if (els.selbstHinweis) els.selbstHinweis.hidden = beschrieben;
      if (els.sNameRow) els.sNameRow.hidden = !beschrieben;
      if (els.sTelefonRow) els.sTelefonRow.hidden = !beschrieben;
      if (beschrieben) notfalldatenZusammenfassung();

      if (els.sTotal) els.sTotal.textContent = nfcEuro(preisFuer(state.farbe, state.beschriftung));
      preiszeilen();
      renderVorschau();
      hideError();
    }

    /* ---------- Fehler & Laden ---------- */
    function showError(text) {
      if (!els.error) return;
      els.error.textContent = text;
      els.error.classList.add('is-visible');
    }
    function hideError() {
      if (!els.error) return;
      els.error.classList.remove('is-visible');
      els.error.textContent = '';
    }
    function setLoading(an) {
      if (!els.cta) return;
      els.cta.classList.toggle('lettra-btn--loading', an);
      els.cta.disabled = an;
      if (els.ctaDots) els.ctaDots.hidden = !an;
    }

    /* ---------- Warenkorb ---------- */
    function addToCart() {
      if (state.beschriftung === 'beschrieben' && !pflichtfelderPruefen(true)) {
        /* Erster Validierungsversuch: Inline-Fehler zeigen, zum
           ersten leeren Feld scrollen und fokussieren. */
        var leeres = els.name && !els.name.value.trim() ? els.name : els.telefon;
        if (leeres) {
          leeres.scrollIntoView({ behavior: 'smooth', block: 'center' });
          leeres.focus({ preventScroll: true });
        }
        return;
      }

      var variant = variantFor(state.farbe, state.beschriftung);
      if (!variant) {
        showError('Diese Kombination ist gerade nicht bestellbar. Bitte melde dich kurz bei uns.');
        return;
      }
      if (!variant.available) {
        showError('Diese Kombination ist gerade nicht verfügbar.');
        return;
      }

      setLoading(true);
      hideError();

      var formData = new FormData();
      formData.append('id', variant.id);
      formData.append('quantity', 1);
      /* Reihenfolge = Anzeigereihenfolge im Warenkorb (Vorgabe):
         Farbe, Daten auf dem Chip, dann — bei "Von uns aufgespielt" —
         Name und Telefon. */
      formData.append('properties[Farbe]', farbVonId(state.farbe).label);
      formData.append('properties[Daten auf dem Chip]', beschriftungVonId(state.beschriftung).label);
      if (state.beschriftung === 'beschrieben') {
        formData.append('properties[Name]', els.name.value.trim());
        formData.append('properties[Telefon]', els.telefon.value.trim());
      }

      var cart = document.querySelector('cart-drawer');
      if (cart && cart.getSectionsToRender) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (s) { return s.id; })
        );
        formData.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          setLoading(false);
          if (data.status) {
            showError(data.description || data.message || 'Das hat leider nicht geklappt. Versuch es bitte noch einmal.');
            return;
          }
          if (cart && cart.renderContents) {
            cart.renderContents(data);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          setLoading(false);
          showError('Keine Verbindung. Prüfe deine Internetverbindung und versuch es noch einmal.');
        });
    }

    /* ---------- Start ---------- */
    baueFarben();
    baueBeschriftungen();
    feldVerdrahten();
    if (els.cta) els.cta.addEventListener('click', addToCart);
    sync();
  }

  function start() {
    document.querySelectorAll('[data-lettra-nfc]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
